import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  --introSpacing: ${fluid(16, 36)};
  --sectionSpacing: ${fluid(16, 40)};

  scroll-margin: var(--headerHeight) 0 0;
`;
const Inner = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
